import { Component } from '@theme/component';
import { DialogComponent } from '@theme/dialog';

class PreviewImageToggle extends Component {
  /**
   * Opens the image preview dialog associated with this toggle button.
   * @param {Event} event - The click event
   */
  handleClick = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const button = /** @type {HTMLElement} */ (event.target).closest('button');
    const dialogId = button?.dataset.dialogId;
    if (!dialogId) return;

    const dialog = document.getElementById(dialogId);
    if (dialog instanceof ImagePreviewDialog) {
      dialog.showDialog();
    }
  };
}

if (!customElements.get('preview-image-toggle')) {
  customElements.define('preview-image-toggle', PreviewImageToggle);
}

class ImagePreviewDialog extends DialogComponent {}

if (!customElements.get('image-preview-dialog')) {
  customElements.define('image-preview-dialog', ImagePreviewDialog);
}

export { PreviewImageToggle, ImagePreviewDialog };